// Renders a "Recently Viewed" product grid from client-side history.
// Reuses Horizon's own RecentlyViewed class (assets/recently-viewed-products.js) for
// storage — this file only adds the rendering, which Horizon doesn't ship.
// Liquid can't read localStorage, so this section has to be JS-rendered; product data
// comes from Shopify's own /products/{handle}.js endpoint (no external services).
import { RecentlyViewed } from '@theme/recently-viewed-products';

async function fetchProduct(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) return null;
    return await response.json();
  } catch {
    return null;
  }
}

function renderCard(product) {
  const image = product.featured_image
    ? `<img src="${product.featured_image.replace('.jpg', '_400x.jpg')}" alt="${product.title}" loading="lazy" width="400" height="400">`
    : '';
  const price = (product.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'INR' });

  return `
    <a class="custom-recently-viewed__card" href="${product.url}">
      <span class="custom-recently-viewed__image">${image}</span>
      <span class="custom-recently-viewed__title">${product.title}</span>
      <span class="custom-recently-viewed__price">${price}</span>
    </a>
  `;
}

async function initRecentlyViewed() {
  const sections = document.querySelectorAll('[data-custom-recently-viewed]:not([data-bound])');

  for (const section of sections) {
    section.setAttribute('data-bound', 'true');

    const currentHandle = section.dataset.currentHandle;
    if (currentHandle) RecentlyViewed.addProduct(currentHandle);

    const handles = RecentlyViewed.getProducts().filter((handle) => handle !== currentHandle);
    if (handles.length === 0) {
      section.hidden = true;
      continue;
    }

    const products = (await Promise.all(handles.map(fetchProduct))).filter(Boolean);
    if (products.length === 0) {
      section.hidden = true;
      continue;
    }

    const grid = section.querySelector('[data-custom-recently-viewed-grid]');
    if (grid) grid.innerHTML = products.map(renderCard).join('');
    section.hidden = false;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentlyViewed);
} else {
  initRecentlyViewed();
}

document.addEventListener('shopify:section:load', initRecentlyViewed);
